<nav class="navbar-chantier navbar-dark">
  <div class="container">
    @if (user) {
      <div class="choix-chantier" (click)="modalService.open(choixChantierModal)"
        [class.active-hover]="user.chantiers && user.chantiers.length > 1">
        @if (selectedChantier) {
          <div class="">
            {{selectedChantier.code + ' ' + selectedChantier.nom}}
          </div>
        }
        @if (!selectedChantier) {
          <div class="">
            Aucun chantier affecté
          </div>
        }
        @if (user.chantiers && user.chantiers.length > 1) {
          <div>
            <i class="bi bi-chevron-down"></i>
          </div>
        }
      </div>
    }
  </div>
</nav>

<ng-template #choixChantierModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title-edl-entree">Choix du chantier</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="list-group">
      @for (chantier of user.chantiers; track chantier) {
        <button type="button" class="list-group-item list-group-item-action" style="height: 60px"
          [class.active]="chantier === selectedChantier"
          (click)="selectChantier(chantier)">{{chantier.code}}
          - {{chantier.nom}}
        </button>
      }
    </div>
  </div>
</ng-template>
